module.exports = __webpack_public_path__ + "static/scale-model-of-walking-tours-of-austin-in-austin-texas-d885935a93bc4aa55a0280f92427153b.png";